import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import WorkMenu from '../../components/WorkMenu/WorkMenu';
import Featured from '../../components/Featured/Featured';
import Archive from '../../components/Archive/Archive';

import styles from './workNav.css';

class WorkNav extends Component {

	constructor(props) {
    super(props);

    this.data = this.props.data;

    this.state = {  
      selectedIndex: 0
    };
  }

  handleSelect(index) {
    this.setState({selectedIndex: index});
  }

	render() {
    const navItems = ['Featured', 'Archive'];
    
		return (
      <div>
  	    <nav className={styles.nav}>
          <ul className={styles.list}>
          {
            navItems.map((label, index) =>
              <li 
                className={
                  `${styles.listItem}
                   ${this.state.selectedIndex === index ? styles.isActive : ''}`
                }
                key={index}
                onClick={() => this.handleSelect(index)}>
                {label}
              </li>
            )
          }
          </ul>
        </nav>
        <WorkMenu index={this.state.selectedIndex}>
          <Featured data={this.data} />
          <Archive data={this.data} />
        </WorkMenu>
      </div>
		);
	}
}

export default WorkNav;


// WEBPACK FOOTER //
// ./src/components/WorkNav/WorkNav.js